<div class="details-card">
  <h3 class="details-card-title">{{ title() }}</h3>
  <div class="details-card-content">
    @for (item of items(); track $index) {
      <div class="detail-item">
        <span class="detail-label">
          {{ item.label }}
          @if (item.action; as action) {
            <button
              mat-icon-button
              type="button"
              class="detail-action-button"
              [attr.aria-label]="action.ariaLabel"
              (click)="action.onClick()"
            >
              <mat-icon class="detail-action-icon material-icons-outlined">
                {{ action.icon }}
              </mat-icon>
            </button>
          }
        </span>
        <span class="detail-value">{{ getDisplayValue(item.value) }}</span>
      </div>
    }
  </div>
</div>
